import { parse } from 'date-fns';

// 施策の葉ノードから親ノードまでを取得する関数
export function ToWarekiFormatter(year: number) {
    const date = new Date(year, 0, 1); // その年の1月1日を基準に和暦変換
    const jpYear = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {
        era: 'long',
        year: 'numeric',
    }).format(date);

    return jpYear + '度';
}
